import { Fragment, forwardRef } from 'react';
import { assert } from '@sindresorhus/is';
import { styled } from '@/styles/stitches.config';
import { ComposableStyledComponentProps } from '@/types/composable-styled-component';

const Span = styled('span', {
  fontWeight: '$semibold',
  borderRadius: '1em',
  paddingBlockStart: '0.05em',
  paddingBlockEnd: '0.2em',
  paddingInline: '0.5em',
  lineHeight: '$1',
  boxDecorationBreak: 'slice',
  '-webkit-box-decoration-break': 'slice',
  backgroundColor: '$unicef',
});

/**
 * This components serves two purposes:
 * 1) It splits up text that needs to be animated wide in it's widest state and splits it into spans which are used to check where line breaks occur
 * 2) This gets rendered server side so we have something that's SEO compatible
 */
export const WideType = forwardRef<
  { el: HTMLSpanElement; i: number },
  ComposableStyledComponentProps
>((props, ref) => {
  const { children, css = {} } = props;

  assert.string(children);

  const words = children.split(' ');
  const wordSpans = words.map((word, wordIndex) => {
    return (
      <Fragment key={`${word}-${wordIndex}`}>
        <span
          ref={(el) => {
            if (el && word && typeof ref === 'function') {
              ref({ el, i: wordIndex });
            }
          }}
        >
          {word}
        </span>
        {wordIndex !== words.length - 1 && ' '}
      </Fragment>
    );
  });

  return <Span css={css}>{wordSpans}</Span>;
});

WideType.displayName = 'WideType';
